<template>
    <div>
        <div class="page-header page-header-small clear-filter">
            <parallax class="page-header-image"
                      style="background-image:url('img/bg3.jpg')">
            </parallax>
            <div class="content-center brand">
                <h1 class="h1-seo">Disclaimer</h1>
            </div>
        </div>

        <section id="general" class="section">
            <div class="container">
                <div class="row justify-content-md-center">
                    <div class="col-md-12 col-lg-8">
                        <p>All information contained on this website has been provided by Alpha Based Capital Fund Management B.V. based on information sources that are supposed to be up to date and accurate.<br /> <br /> This website is not intended as advice but serves for information purposes only. Despite the fact that the greatest care has been taken by the authors, Alpha Based Capital Fund Management B.V. does not assume any responsibility for decisions taken on the basis of the information on this website.<br /> <br /> The information contained on this website may therefore be regarded as indicative. If you are considering to participate in a Fund of Alpha Based Capital Fund Management B.V., on the basis of this information is it is imperative that you should be informed and advised by an independent expert financial advisor. Additionally, we recommend that you take notice of the prospectus and the financial information leaflet (“financiële bijsluiter”) of the Fund.<br /> <br /> Alpha Based Capital Fund Management B.V. has obtained a license to manage funds as described in article 2:65 Wft (the Netherlands Financial Supervision Act). It is therefore regulated by the Netherlands Authority for the Financial Markets (AFM) an dthe Dutch Central Bank (DNB).<br /> <br /> The value of your investment can fluctuate. Returns achieved in the past do not offer guarantee for return in the future.<br /> <br /> The results of each investment are influenced by (transaction) costs incurred. Investing in any form involves financial risks. Most of the investment funds are designed for investment in the medium to long term. By investing in a fund, you can achieve (capital) gains, but it is also possible to lose money.</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import { Parallax } from '@/components';

    export default {
        name: 'index',
        bodyClass: 'index-page',
        data() {
            return {
            }
        },
        components: {
            Parallax
        }
    };
</script>
<style></style>
